var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-navbar", { attrs: { toggleable: "md" } }, [
    _c(
      "div",
      { staticClass: "mx-auto d-sm-flex d-block flex-sm-nowrap" },
      [
        _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
        _vm._v(" "),
        _c(
          "b-collapse",
          {
            staticClass: "text-center collapse navbar-collapse",
            attrs: { "is-nav": "", id: "nav_collapse" }
          },
          [
            _c(
              "b-navbar-nav",
              [
                _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.home")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/profile" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.profile")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/guardians" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.guardians.topLevel")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/photos" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.photos")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/documents" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.documents")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/contacts" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.contacts")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/pets" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.pets")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/my-funeral" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.funeral.topLevel")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/account" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.account")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { on: { click: _vm.logout } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.logout")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-nav-item-dropdown",
                  {
                    attrs: {
                      text: _vm.$t("menu.items.languageSwitcher"),
                      right: ""
                    }
                  },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            _vm.switchLang("de")
                          }
                        }
                      },
                      [_vm._v("Deutsch")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            _vm.switchLang("en")
                          }
                        }
                      },
                      [_vm._v("English")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6324675e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6324675e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuComponent.vue
// module id = null
// module chunks = 